<template>
  <div class="map-container">
    <Map />
  </div>
</template>
<script>

import Map from '@common/components/map';

export default {
  components: {
    Map,
  },
};
</script>
<style>
.map-container {
  position: relative;
  width: 100%;
  height: 400px;
}
</style>
